import config from '@/config';
import filters from '@/filters';
import mixins from '@/mixins';
import widgets from '@/widgets';
import '@/styles/app.less';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

export default function init(Vue) {
  process.env.NODE_ENV === "production" && Sentry.init({
    dsn: 'http://ad22bc14674b45d9b2364a5ba769f179@sentry.laixue.com/19',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    logErrors: true
  });

  // 远程js组件
  Vue.component('remote-script', {
    props: {
      src: {
        type: String,
        required: true,
      }
    },
    render: function (createElement) {
      return createElement('script', {
        attrs: {
          type: 'text/javascript',
          src: this.src,
        },
      });
    },
  });

  // 远程css组件
  Vue.component('remote-stylesheet', {
    props: {
      href: {
        type: String,
        required: true,
      }
    },
    render: function (createElement) {
      return createElement('link', {
        attrs: {
          rel: 'stylesheet',
          href: this.href,
        },
      });
    },
  });

  // 注册自定义组件
  widgets.install(Vue, config);

  // 注册过滤器
  Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
  })

  // 混入
  Vue.mixin(mixins);
}
